// MEO landmark ads (Phase 1, Step 4-4, 2026-05-01):
//   占い文言プール用 MobX store。
// T3-B PR 4-bis (2026-05-12):
//   listByTemplateMotif / createByTemplateMotif / remove を追加
//   (= 採否トグル + 採用中ゼロ防止 validation は backend 側で 409 返す)。

import { OmikujiTextApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class OmikujiTextStore extends BaseStore {
    items: any[] = [];
    total: number = 0;
    // PR 4-bis (2026-05-12): template_motif 配下の文言プール画面用 (= 言語タブ + N 候補)
    templateMotifTexts: any[] = [];
    templateMotifMeta: any = null;
    api: OmikujiTextApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            items: observable,
            total: observable,
            templateMotifTexts: observable,
            templateMotifMeta: observable,
            list: flow.bound,
            update: flow.bound,
            generate: flow.bound,
            listByTemplateMotif: flow.bound,
            createByTemplateMotif: flow.bound,
            remove: flow.bound
        });
        this.api = new OmikujiTextApi();
    }

    *list(filters?: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.list, filters);
            if (res?.ok) {
                this.items = res.data?.items ?? [];
                this.total = res.data?.total ?? 0;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *update(payload: { id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.update, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *generate(payload: { fortune: number, motif: string, language: string, count: number }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.generate, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    // PR 4-bis (2026-05-12): 占い文言プール CMS UI 用
    *listByTemplateMotif(payload: { template_motif_id: string | number, language?: string }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.listByTemplateMotif,
                payload
            );
            if (res?.ok) {
                this.templateMotifTexts = res.data?.items ?? [];
                this.templateMotifMeta = res.data?.template_motif ?? null;
            }
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *createByTemplateMotif(payload: { template_motif_id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.createByTemplateMotif,
                payload
            );
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *remove(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.remove, id);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }
}
